<template>
  <table>
    <tbody>
      <td width="100px">
        <div class="dailydigesttime ui selection dropdown">
          <input type="hidden" name="digestTime">
          <i class="dropdown icon"></i>
          <div class="default text">Daily Digest Time</div>
          <div class="menu">
            <div class="item" data-value="0">12am</div>
            <div class="item" data-value="1">1am</div>
            <div class="item" data-value="2">2am</div>
            <div class="item" data-value="3">3am</div>
            <div class="item" data-value="4">4am</div>
            <div class="item" data-value="5">5am</div>
            <div class="item" data-value="6">6am</div>
            <div class="item" data-value="7">7am</div>
            <div class="item" data-value="8">8am</div>
            <div class="item" data-value="9">9am</div>
            <div class="item" data-value="10">10am</div>
            <div class="item" data-value="11">11am</div>
            <div class="item" data-value="12">12pm</div>
            <div class="item" data-value="13">1pm</div>
            <div class="item" data-value="14">2pm</div>
            <div class="item" data-value="15">3pm</div>
            <div class="item" data-value="16">4pm</div>
            <div class="item" data-value="17">5pm</div>
            <div class="item" data-value="18">6pm</div>
            <div class="item" data-value="19">7pm</div>
            <div class="item" data-value="20">8pm</div>
            <div class="item" data-value="21">9pm</div>
            <div class="item" data-value="22">10pm</div>
            <div class="item" data-value="23">11pm</div>
          </div>
        </div>
      </td>
      <td width="300px">
        <div class="timezone ui selection dropdown">
          <input type="hidden"/>
          <i class="dropdown icon"></i>
          <div class="default text">Timezone</div>
          <div class="menu">
            <div class="item" data-value="-12">UTC-12 (Baker Island)</div>
            <div class="item" data-value="-11">UTC-11 (Niue)</div>
            <div class="item" data-value="-10">UTC-10 (Honolulu, Tahiti)</div>
            <div class="item" data-value="-9">UTC-09 (Alaska)</div>
            <div class="item" data-value="-8">UTC-08 (Los Angeles, Seattle, Vancouver)</div>
            <div class="item" data-value="-7">UTC-07 (Denver, Edmonton, Tijuana)</div>
            <div class="item" data-value="-6">UTC-06 (Austin, Chicago, Mexico City, Milwaukee)</div>
            <div class="item" data-value="-5">UTC-05 (Lima, New York, Miami, Montreal)</div>
            <div class="item" data-value="-4">UTC-04 (Caracas, Halifax)</div>
            <div class="item" data-value="-3">UTC-03 (Buenos Aires, Montevideo)</div>
            <div class="item" data-value="-2">UTC-02 (Rio de Janeiro, São Paulo)</div>
            <div class="item" data-value="-1">UTC-01</div>
            <div class="item" data-value="0">UTC+00 (London, Lisbon, Reykjavik)</div>
            <div class="item" data-value="1">UTC+01 (Amsterdam, Berlin, Oslo)</div>
            <div class="item" data-value="2">UTC+02 (Athens, Cairo, Helsinki, Johannesburg)</div>
            <div class="item" data-value="3">UTC+03 (Istanbul, Moscow, Madagascar)</div>
            <div class="item" data-value="4">UTC+04 (Dubai, Tbilisi)</div>
            <div class="item" data-value="5">UTC+05 (Lahore, Yekaterinburg)</div>
            <div class="item" data-value="6">UTC+06 (Almaty, Kathmandu)</div>
            <div class="item" data-value="7">UTC+07 (Bangkok, Jakarta)</div>
            <div class="item" data-value="8">UTC+08 (Beijing, Hong Kong, Kuala Lumpur, Perth)</div>
            <div class="item" data-value="9">UTC+09 (Seoul, Tokyo)</div>
            <div class="item" data-value="10">UTC+10 (Vladivostok)</div>
            <div class="item" data-value="11">UTC+11 (Melbourne, Sydney)</div>
            <div class="item" data-value="12">UTC+12 (Auckland)</div>
          </div>
        </div>
      </td>
      <td width="150px">
        <div class="ui checkbox" width="300px">
          <input type="checkbox" name="timezoneAdjustToDST" v-model="timezoneAdjustToDST">
          <label>Adjust to Daylight Saving Time</label>
        </div>
      </td>
    </tbody>
  </table>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    return {
      timezoneOffset: this.emailAddress.timezoneOffset,
      timezoneAdjustToDST: this.emailAddress.timezoneAdjustToDST,
      timezoneElement: null,
      digestEmailHour: this.emailAddress.digestEmailHour,
      dailyDigestTimeElement: null,
      dirty: false,
    }
  },
  props: ['emailAddress'],
  methods: {
    toJson: function () {
      return {
        sellerId: this.seller.sellerId,
        name: this.name
      }
    },
    recalc: function () {
      this.dirty = this.timezoneOffset !== this.emailAddress.originalTimezoneOffset || this.timezoneAdjustToDST !== this.emailAddress.originalTimezoneAdjustToDST || this.digestEmailHour !== this.emailAddress.originalDigestEmailHour
      this.$emit('digestTimingUpdated', this.timezoneOffset, this.timezoneAdjustToDST, this.digestEmailHour)
    },
  },
  mounted: function () {
    this.timezoneElement = $(this.$el).find('.timezone.ui.selection.dropdown')[0]
    $(this.timezoneElement).dropdown({
      onChange: (value, text) => {
        this.timezoneOffset = parseInt(value)
      }
    })
    if (this.timezoneOffset != null) $(this.timezoneElement).dropdown('set exactly', this.timezoneOffset)
    this.dailyDigestTimeElement = $(this.$el).find('.dailydigesttime.ui.selection.dropdown')[0]
    $(this.dailyDigestTimeElement).dropdown({
      onChange: (value, text) => {
        this.digestEmailHour = parseInt(value)
      }
    })
    if (this.digestEmailHour != null) $(this.dailyDigestTimeElement).dropdown('set exactly', this.digestEmailHour)
  },
  watch: {
    timezoneOffset: function () {
      this.recalc()
    },
    timezoneAdjustToDST: function () {
      this.recalc()
    },
    digestEmailHour: function () {
      this.recalc()
    },
  }
}
</script>



// WEBPACK FOOTER //
// DailyDigestTiming.vue?2666ac7c